import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4dec6bd7&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/Icon.vue').default,Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default})
